import React, { useEffect } from 'react';
import { useRichIntl, useRealm, LoadingPage } from 'ciam-self-service-shared';
import redirectInbound from './steps/redirectInbound';
import { secondStepInit } from './steps/init';
import Page, { AUTH_TYPE } from '../../../common/Page';
import useInboundTreeErrorHandler, { useSuccessUrlErrorHandler } from './steps/useInboundTreeErrorHandler';
import { createSessionAction, createSessionStatus } from 'components/Login/actions';
import { useDispatch } from 'react-redux';
import { getAMRealms } from 'utils/realmMapping';

function Code() {
  const inboundTreeErrorHandler = useInboundTreeErrorHandler();
  const realm = useRealm();
  const richIntl = useRichIntl();
  const dispatch = useDispatch();
  const authId = sessionStorage.getItem('inboundAuthId');
  const successUrlErrorHandler = useSuccessUrlErrorHandler();

  useEffect(() => {
    (async () => {
      try {
        const { successUrl, tokenId } = await secondStepInit(realm, authId);

        const sessionStep = {
          payload: {
            tokenId,
            realm: getAMRealms(realm),
          },
        };

        await createSessionAction(sessionStep).then((sessionData) => dispatch(createSessionStatus(sessionData)));

        const inboundRedirect = redirectInbound(successUrl);
        if (inboundRedirect === successUrl) {
          sessionStorage.clear('inboundAuthId');
          window.location.href = successUrl;
        } else {
          sessionStorage.clear('inboundAuthId');
          successUrlErrorHandler();
        }
      } catch (err) {
        inboundTreeErrorHandler(err);
      }
    })();
  }, [realm, authId, inboundTreeErrorHandler, successUrlErrorHandler, dispatch]);

  return (
    <Page title={richIntl.formatMessage({ id: 'signin.page.title' })} authType={AUTH_TYPE.NONE}>
      <LoadingPage />
    </Page>
  );
}

export default Code;
